import { format, parseISO } from 'date-fns'
import dateFnsTz from 'date-fns-tz'
import lt from 'date-fns/locale/lt/index.js'

const { formatInTimeZone } = dateFnsTz

export const LT_LCID_STRING = 'lt-LT'
export const LT_DATE_FORMAT = 'yyyy-MM-dd'
export const LT_TIME_FORMAT = 'HH:mm'

export function getFullYear(date: string | Date | null | undefined, locale?: string) {
  const dateLocale = locale ?? LT_LCID_STRING

  if (!date) {
    return '-'
  }

  if (date instanceof Date) {
    return format(date, LT_DATE_FORMAT, { locale: lt })
  }

  const parsedDate = parseISO(date).toLocaleDateString(dateLocale)

  return parsedDate
}

export function getFullTime(date: string | Date | null | undefined) {
  if (!date) {
    return '-'
  }

  if (date instanceof Date) {
    return format(date, LT_TIME_FORMAT)
  }

  const parsedDate = format(parseISO(date), LT_TIME_FORMAT)

  return `${parsedDate}`
}

export function changeTimezone(usDate: string, timezone?: string) {
  if (!timezone) {
    return usDate
  }

  const usDateTimezone = `${usDate}-05:00`

  return formatInTimeZone(usDateTimezone, timezone, `${LT_DATE_FORMAT} ${LT_TIME_FORMAT}`)
}
